<template></template>
<script>
export default {
  created() {
    this.$store.dispatch("auth/auth_logout").then(() => {
      this.$router.push({ name: "home" });
    });
  }
};
</script>

